import {
  DatasetControl,
  ReferenceDatasetControl,
} from '../../../../types/types';

export const getControlVisibility = (
  control: DatasetControl,
  currentRow: any,
  selectedRows: any[],
  referenceDatasetControls: ReferenceDatasetControl[] | undefined,
  isGridEmpty: boolean,
  masterRow?: any
): boolean => {
  if (referenceDatasetControls) {
    return referenceDatasetControls.some(({ name }) => name === control.name);
  }

  if (control.visibleWhen) {
    const row = control.visibleWhen.source === 'masterRow' ? masterRow : currentRow;
    const value = row?.[control.visibleWhen.field];
    if ('equals' in control.visibleWhen && value !== control.visibleWhen.equals) {
      return false;
    }
    if ('notEquals' in control.visibleWhen && value === control.visibleWhen.notEquals) {
      return false;
    }
    if (control.visibleWhen.in && !control.visibleWhen.in.includes(value)) {
      return false;
    }
  }

  const { selectionMode, action } = control;

  if (
    isGridEmpty &&
    action?.type === 'form' &&
    action.formType === 'edit' &&
    selectionMode !== 'any'
  ) {
    return false;
  }

  switch (selectionMode) {
    case 'dontcare_useall':
    case 'any':
      return true;
    case 'justone':
      return currentRow !== null;
    case 'oneormore':
      return selectedRows.length > 0 || currentRow !== null;
    default:
      return true;
  }
};
